import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ExtrasInfo } from '@shared/services/extras/_interfaces_/extras-info.interface';
import { StepperBarStep } from '@shared/services/extras/_interfaces_/extras-steps.interface';
import { ExtrasOverviewService } from '@shared/services/extras/extras-overview.service';

@Component({
  selector: 'app-extras-page',
  templateUrl: './extras-page.component.html',
  styleUrls: ['./extras-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtrasPageComponent implements OnInit {
  private extrasOverviewService = inject(ExtrasOverviewService);
  public extrasSteps: Array<StepperBarStep>;

  receivedData: ExtrasInfo;

  constructor() { }

  ngOnInit(): void {
    this.extrasSteps = [
      { stepName: "Extra's" },
      { stepName: "Overzicht" },
      { stepName: "Something else" }
    ];

    const storedData = localStorage.getItem('extrasInfo');

    if (storedData) {
      this.receivedData = JSON.parse(storedData);
    } else {
      this.receivedData = this.extrasOverviewService.getExtrasData();
    }
  }
}
